
import React, { Component } from 'react';
import { Modal, Form, Input, Tabs, Row, Col, Switch, Divider, InputNumber, DatePicker } from 'antd';
import moment from 'moment';


import http from '../../../axios/http';
import validator from '../../../util/validator';
import ocr from '../../../util/ocr';
import Loading from '../../ui/Loading';

import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';
import Image from '../../ui/Image';
import Scanner from '../../ui/Scanner';
//会员选择
import MemberSelect from '../../crm/member/MemberSelect';
import MemberUserSelect from '../../crm/member/MemberUserSelect';


import '../../../style/common/uploadImage.css';

const FormItem = Form.Item;

const dealField = [{
    "text": "过户类型",
    "field": "transferType",
    "select": true,
    "category": "Transfer_Type"
}, {
    "text": "车辆转入地",
    "field": "destination",
}, {
    "text": "车价",
    "field": "amount",
    "number": true,
    rules: [
        { required: true, message: '车价不能为空!' }
    ],
}, {
    "text": "是否代办",
    "field": "agent",
    radio: true,
    payState: true
}, {
    "text": "代理公司",
    "field": "agency",
    "member": true,
    rules: [
        { required: true, message: '代理公司不能为空!' }
    ],
    agent: true,
    payState: true
}, {
    "text": "代理人员",
    "field": "agentMan",
    "memberUser": true,
    rules: [
        { required: true, message: '代理人员不能为空!' }
    ],
    agent: true,
    payState: true
}, {
    "text": "代理人电话",
    "field": "agentTel",
    rules: [
        { required: true, message: '代理人电话不能为空!' },
        validator.tel
    ],
    agent: true
}];

const vehicleField = [{
    "text": "登记证书编号",
    "field": "vehicle.registerNo",
    rules: [
        { required: true, message: '登记证书编号不能为空！' },
        { max: 12, message: '登记证书编号为12位数字！' },
        { min: 12, message: '登记证书编号为12位数字！' },
        validator.num
    ]
}, {
    "text": "车架号",
    "field": "vehicle.vin",
    rules: [
        { required: true, message: '车架号不能为空!' },
        { max: 32, message: '车架号不能超过32个字符！' },
        validator.enNum
    ]
}, {
    "text": "车牌号码",
    "field": "vehicle.plateNo",
    rules: [
        { required: true, message: '车牌号码不能为空!' },
        validator.plateNo
    ]
}, {
    "text": "厂牌型号",
    "field": "vehicle.brandModel",
    rules: [
        { required: true, message: '厂牌型号不能为空!' },
        { max: 64, message: '厂牌型号不能超过64个字符！' },
    ]
}
, {
    "text": "初登日期",
    "field": "vehicle.registerDate",
    date: true,
}
, {
    "text": "车辆品牌",
    "field": "vehicle.brand",
    rules: [
        { max: 64, message: '车辆品牌不能超过64个字符！' },
    ]
}, {
    "text": "车辆型号",
    "field": "vehicle.model",
    rules: [
        { max: 64, message: '车辆型号不能超过64个字符！' },
    ]
}, {
    "text": "发动机型号",
    "field": "vehicle.engineModel",
    rules: [
        // { required: true, message: '发动机型号不能为空!' },
        { max: 64, message: '发动机型号不能超过16个字符！' },
        validator.lineEnNum
    ]
}, {
    "text": "发动机号",
    "field": "vehicle.engineNo",
    rules: [
        // { required: true, message: '发动机号不能为空!' },
        { max: 64, message: '发动机号不能超过16个字符！' },
        validator.lineEnNum
    ]
}
, {
    "text": "出厂日期",
    "field": "vehicle.productionDate",
    date: true,
}
, {

    "text": "车辆类型",
    "field": "vehicle.vehicleType",
    "category": "VEHICLE_TYPE",
    select: true,
    needPull: true
}, {
    "text": "燃油种类",
    "field": "vehicle.fuelType",
    "category": "VEHICLE_FUEL_TYPE",
    select: true
}, {
    "text": "使用性质",
    "field": "vehicle.useProperty",
    "category": "VEHICLE_USE_PROPERTY",
    select: true,
    needPull: true
}, {
    "text": "是否进口车",
    "field": "vehicle.isImported",
    radio: true
}, {
    "text": "排放标准",
    "field": "vehicle.emissionStandard",
    "category": "VEHICLE_EMISSION_STANDARD",
    select: true
}, {
    "text": "号牌种类",
    "field": "vehicle.plateType",
    "category": "VEHICLE_PLATE_TYPE",
    select: true
}, {
    "text": "OCR识别",
    "field": "vehicleOCR",
    iamge: true
}];


const buyer = [{
    "text": "证件类型",
    "field": "buyer.creditType",
    "category": "CREDIT_TYPE",
    select: true
}, {
    "text": "证件编号",
    "field": "buyer.creditNo",
    rules: [
        { required: true, message: '证件编号不能为空!' },
        validator.creditNo
    ]
}, {
    "text": "买方姓名",
    "field": "buyer.name",
    rules: [
        { required: true, message: '买方姓名不能为空!' },
        { max: 64, message: '买方姓名不能超过32个字符！' },
    ]
}, {
    "text": "联系电话",
    "field": "buyer.tel",
    rules: [
        { required: true, message: '联系电话不能为空!' },
        validator.tel
    ]
    // }, {
    //     "text": "户籍地址",
    //     "field": "buyer.censusAddress",
    //     rules: [
    //         // { required: true, message: '户籍地址不能为空!' },
    //         { max: 128, message: '户籍地址不能超过128个字符！' },
    //     ]
}, {
    "text": "居住地址",
    "field": "buyer.residenceAddress",
    "textarea": true,
    rules: [
        { required: true, message: '居住地址不能为空!' },
        { max: 128, message: '居住地址不能超过128个字符！' },
    ]
}, {
    "text": "OCR识别",
    "field": "buyerOCR",
    iamge: true
}];

const seller = [{
    "text": "证件类型",
    "field": "seller.creditType",
    "category": "CREDIT_TYPE",
    select: true
}, {
    "text": "证件编号",
    "field": "seller.creditNo",
    rules: [
        { required: true, message: '证件编号不能为空!' },
        validator.creditNo
    ]
}, {
    "text": "卖方姓名",
    "field": "seller.name",
    rules: [
        { required: true, message: '买方姓名不能为空!' },
        { max: 64, message: '买方姓名不能超过32个字符！' },
    ]
}, {
    "text": "联系电话",
    "field": "seller.tel",
    rules: [
        { required: true, message: '联系电话不能为空!' },
        validator.tel
    ]
}, {
    //     "text": "户籍地址",
    //     "field": "seller.censusAddress",
    //     rules: [
    //         // { required: true, message: '户籍地址不能为空!' },
    //         { max: 128, message: '户籍地址不能超过128个字符！' },
    //     ]
    // }, {
    "text": "居住地址",
    "field": "seller.residenceAddress",
    "textarea": true,
    rules: [
        { required: true, message: '居住地址不能为空!' },
        { max: 128, message: '居住地址不能超过128个字符！' },
    ]
}, {
    "text": "OCR识别",
    "field": "sellerOCR",
    iamge: true
}];

const tradeImage = [{
    text: '行驶证',
    field: 'vehicleLicense'
}, {
    text: '机动车登记证首页',
    field: 'vehicleRegister'
}, {
    text: '机动车登记证尾页',
    field: 'vehicleRegister_1'
}, {
    text: '买家身份证（人像）',
    field: 'buyerCreditFront'
}, {
    text: '买家身份证（国徽）',
    field: 'buyerCreditBack'
}, {
    text: '卖家身份证（人像）',
    field: 'sellerCreditFront'
}, {
    text: '卖家身份证（国徽）',
    field: 'sellerCreditBack'
}]

// const checkImage = [{
//     text: '左前方斜视45度',
//     field: 'leftFront'
// }, {
//     text: '右后方斜视45度',
//     field: 'rightBack'
// }, {
//     text: '车辆识别代号',
//     field: 'vinPhoto'
// }, {
//     text: '三角警示牌',
//     field: 'warningTriangle'
// }, {
//     text: '前排主副驾安全带',
//     field: 'frontRow'
// }, {
//     text: '发动机',
//     field: 'engine'
// }, {
//     text: '机动车标准照',
//     field: 'standard'
// }, {
//     text: '车架号拓印膜',
//     field: 'vinRubbing'
// }, {
//     text: '其他照片1',
//     field: 'checkMore_1'
// }, {
//     text: '其他照片2',
//     field: 'checkMore_2'
// }]

class ApplicationEditForm extends Component {
    state = {
        activeKey: 'deal',
        visible: false,
        imageField: '',
        imageIndex: 0,
        dictSelect: {},
        agency: '',  //代办单位
        showAgent: true,

        loading: false,

        //上传特定相关照片
        fileList: {},
        imageUrl: {},
        //其他额外照片
        otherImagesUrl: [],
        otherImage: [],
    }

    componentDidMount() {
        if (this.props.initFunc) {
            this.props.initFunc(this.initEdit);
        }
    }

    initEdit = (editData) => {
        let agency = editData.agency;
        if (agency != null && agency !== "") {
            this.setState({ agency: agency });
            this.loadMemberUserInfo(agency);
        }

        let image = editData.image;
        let fileList = {};
        let imageUrl = {};
        if (image != null) {
            for (var field in image) {
                if (image[field] != null && image[field] !== "") {
                    fileList[field] = "data:image/jpeg;base64," + image[field].replace(/\r\n/g, "");
                }
            }
            imageUrl = editData.imageUrl;
        }
        let otherImages = editData.otherImages;
        let otherImagesUrl = [];
        let otherImage = [];
        if (otherImages != null && otherImages.length > 0) {
            for (let index in otherImages) {
                if (otherImages[index] != null && otherImages[index] !== "") {
                    otherImage.push("data:image/jpeg;base64," + otherImages[index].replace(/\r\n/g, ""));
                }
            }
            otherImagesUrl = editData.otherImagesUrl;
        }
        this.setState({ fileList: fileList, otherImage: otherImage, imageUrl: imageUrl, otherImagesUrl: otherImagesUrl });
    }

    // componentWillReceiveProps() {
    //     if (!this.props.visible) {
    //         let agency = this.props.editData.agency;
    //         if (agency != null && agency !== "") {
    //             this.setState({ agency: agency });
    //         }

    //         let image = this.props.editData.image;
    //         let fileList = {};
    //         let imageUrl = {};
    //         if (image != null) {
    //             for (var field in image) {
    //                 if (image[field] != null && image[field] !== "") {
    //                     fileList[field] = "data:image/jpeg;base64," + image[field].replace(/\r\n/g, "");
    //                 }
    //             }
    //             imageUrl = this.props.editData.imageUrl;
    //         }
    //         let otherImages = this.props.editData.otherImages;
    //         let otherImagesUrl = [];
    //         let otherImage = [];
    //         if (otherImages != null && otherImages.length > 0) {
    //             for (let index in otherImages) {
    //                 if (otherImages[index] != null && otherImages[index] !== "") {
    //                     otherImage.push("data:image/jpeg;base64," + otherImages[index].replace(/\r\n/g, ""));
    //                 }
    //             }
    //             otherImagesUrl = this.props.editData.otherImagesUrl;
    //         }
    //         this.setState({ fileList: fileList, otherImage: otherImage, imageUrl: imageUrl, otherImagesUrl: otherImagesUrl });
    //     }
    // }

    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            if (err) {
                messager.notify("有未填写的必填项，请先填写完再保存！", "异常", "error");
                return;
            }
            this.setState({ loadingVisible: true });
            let buyerId = this.props.editData["buyer.id"];
            if (buyerId !== undefined && buyerId != null) {
                values.buyer.id = buyerId;
            }
            let sellerId = this.props.editData["seller.id"];
            if (sellerId !== undefined && sellerId != null) {
                values.seller.id = sellerId;
            }
            values["applicationId"] = this.props.editData.applicationId;
            let imageUrl = this.state.imageUrl;
            let fileList = this.state.fileList;
            let image = {};
            for (let key in fileList) {
                if (imageUrl[key] == null || imageUrl[key] === "") {
                    image[key] = fileList[key];
                } else {
                    image[key] = imageUrl[key];
                }
            }
            values["image"] = image;
            this.transferData(values, "buyer");
            this.transferData(values, "seller");
            this.transferData(values, "vehicle");
            this.transferData(values, "image");
            this.transferData(values, "ticket");
            if (values["vehicle.productionDate"] != null) {
                values["vehicle.productionDate"] = values["vehicle.productionDate"].format("YYYY-MM-DD");
            }
            if (values["vehicle.registerDate"] != null) {
                values["vehicle.registerDate"] = values["vehicle.registerDate"].format("YYYY-MM-DD");
            }
            values["vehicle.isImported"] = values["vehicle.isImported"] === true ? 1 : 0;
            values["agent"] = values["agent"] ? 1 : 0;
            delete values["image.applicationId"];

            let other = [];
            let otherImage = this.state.otherImage;
            let otherImagesUrl = this.state.otherImagesUrl;
            for (let i = 0; i < this.state.otherImage.length; i++) {
                if (otherImagesUrl.length > i && otherImagesUrl[i] != null && otherImagesUrl[i] !== "") {
                    other.push(otherImagesUrl[i]);
                } else {
                    other.push(otherImage[i]);
                }
            }
            values["otherImage"] = JSON.stringify(other);
            http.post({
                url: '/application/saveApplication',
                data: values,
                success: (res) => {
                    this.props.successCallback();
                    this.props.onCancel();
                    messager.notify("保存成功！");
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    };
    transferData = (res, field) => {
        let value = res[field];
        for (let key in value) {
            res[field + "." + key] = value[key];
        }
        delete res[field];
    }
    //字典选择改变时触发
    dictSelect = (field, dict) => {
        if (dict != null) {
            const { form } = this.props;
            if (field === "agency") {
                form.setFieldsValue({
                    "agentTel": dict.contactNumber,
                    "agentMan": ""
                });
                this.setState({ agency: dict.code });
                this.loadMemberUserInfo(dict.code);
            } else if (field === "tradeVehicleType") {
                form.setFieldsValue({
                    "commission": dict.des
                });
            }
        }
    }
    //swith选择改变时触发
    radioChange = (field, checked) => {
        if (field === "agent") {
            this.setState({ showAgent: checked });
            const { editData } = this.props;
            if (checked) {
                editData.agent = 1;
            } else {
                editData.agent = 0;
            }
        }
    }
    onRef = (field, dom) => {
        let dictSelect = this.state.dictSelect;
        dictSelect[field] = dom;
        this.setState({ dictSelect: dictSelect });
    }
    createDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i += 2) {
            let item = (<Row key={i}>
                <Col span={11}>
                    {this.createDomItem(data[i])}
                </Col>
                <Col span={11} offset={2}>
                    {(i + 1) < data.length ? this.createDomItem(data[i + 1]) : ''}
                </Col>
            </Row>);
            dom.push(item);
        }
        return dom;
    };
    createDomItem = (item) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let domItem = "";
        let payState = editData.payState;
        if (item.agent === true && editData.agent === 0) {

        } else {
            domItem = (
                <FormItem label={item.text + "："}>
                    {item.iamge ?
                        <Image openScanner={this.showModal.bind(this, item.field)}
                            onChange={this.handleUploadImage.bind(this, item.field)}
                            type="button" />
                        :
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue:
                                item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                                    : item.radio ? editData[item.field] === 1
                                        : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.select ?
                                <DictSelect category={item.category} onSelect={item.onSelect ? this.dictSelect.bind(this, item.field) : null}
                                    onRef={item.needPull === true ? this.onRef.bind(this, item.field) : null}
                                    disabled={item.payState === true && payState === 1 && editData.agent === 0}
                                />
                                : item.radio ?
                                    // <Switch checkedChildren="是" unCheckedChildren="否" checked={this.state.radioCheck} onClick={(checked) => { this.setState({ radioCheck: checked }) }} />
                                    <Switch checkedChildren="是" unCheckedChildren="否" onChange={this.radioChange.bind(this, item.field)} disabled={item.payState === true && payState === 1} />
                                    : item.number ?
                                        <InputNumber precision={2} min={0.00} style={{ width: '100%' }} />
                                        : item.date ?
                                            <DatePicker style={{ width: '100%' }} />
                                            : item.member ? <MemberSelect agent={1} onSelect={this.dictSelect.bind(this, item.field)} disabled={item.payState === true && payState === 1} />
                                                : item.memberUser ? <MemberUserSelect loadMemberUserInfo={(func) => this.loadMemberUserInfo = func} memberCode={this.state.agency} disabled={item.payState === true && payState === 1} />
                                                    : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                                        : <Input disabled={item.disabled === true} />
                        )
                    }
                </FormItem>
            );
        }
        return domItem;
    }

    createImageDom = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let field = item.field;
            let file = this.state.fileList[field];
            dom.push(
                <Col span={4} key={field} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, field)}
                        onChange={this.handleUploadImage.bind(this, field)}
                        onRemove={this.handleRemoveImage.bind(this, field)}
                        file={file}
                        text={item.text}
                        url={this.state.imageUrl[item.field]}
                    />
                </Col>
            );
        }
        return dom;
    }
    createOtherImageDom = () => {
        let dom = [];
        let data = this.state.otherImage;
        let otherImagesUrl = this.state.otherImagesUrl;
        for (let i = 0; i <= data.length; i++) {
            let file = data[i];
            let url = i < otherImagesUrl.length ? otherImagesUrl[i] : null;
            dom.push(
                <Col span={4} key={i} style={{ height: '112px' }}>
                    <Image
                        openScanner={this.showModal.bind(this, "otherImage")}
                        onChange={this.handleUploadImage.bind(this, "otherImage")}
                        onRemove={this.handleRemoveImage.bind(this, "otherImage", i)}
                        original={true}
                        file={file}
                        text={''}
                        url={url}
                    />
                </Col>
            );
        }
        return dom;
    }
    handleUploadImage = (field, { base64 }) => {
        if (field === "vehicleOCR") {
            //调用百度ocr识别
            ocr.baiduOCR({
                image: base64,
                imageType: 'VL',
                callback: (res) => {
                    const { form } = this.props;
                    let vehicleTypeList = this.state.dictSelect["vehicle.vehicleType"].state.dictList;
                    let usePropertyList = this.state.dictSelect["vehicle.useProperty"].state.dictList;
                    let useProperty = '';
                    let vehicleType = '';
                    if (vehicleTypeList != null && res["车辆类型"]["words"] != null) {
                        for (let i = 0; i < vehicleTypeList.length; i++) {
                            if (vehicleTypeList[i].name === res["车辆类型"]["words"]) {
                                vehicleType = vehicleTypeList[i].code;
                            }
                        }
                    }
                    if (usePropertyList != null && res["使用性质"]["words"] != null) {
                        for (let i = 0; i < usePropertyList.length; i++) {
                            if (usePropertyList[i].name === res["使用性质"]["words"]) {
                                useProperty = usePropertyList[i].code;
                            }
                        }
                    }
                    form.setFieldsValue({
                        "vehicle.vin": res["车辆识别代号"]["words"].replaceAll("O","0").replaceAll("I","1"),
                        "vehicle.brandModel": res["品牌型号"]["words"],
                        "vehicle.brand": res["品牌型号"]["words"],
                        "vehicle.model": res["品牌型号"]["words"],
                        "vehicle.plateNo": res["号牌号码"]["words"],
                        "vehicle.engineNo": res["发动机号码"]["words"],
                        // "vehicle.vehicleType": res["车辆类型"]["words"],
                        // "vehicle.useProperty": res["使用性质"]["words"]
                        "vehicle.vehicleType": vehicleType,
                        "vehicle.useProperty": useProperty,
                        
                        "seller.name": res["所有人"]["words"],
                        "seller.residenceAddress": res["住址"]["words"],
                    });
                }
            });
        } else if (field === "buyerOCR" || field === "sellerOCR") {
            const { form } = this.props;
            let imageType = "P1";
            if (field === "buyerOCR") {
                imageType = form.getFieldValue("buyer.creditType");
            } else {
                imageType = form.getFieldValue("seller.creditType");
            }
            //调用百度ocr识别
            ocr.baiduOCR({
                image: base64,
                imageType: imageType,
                idCardSide: 'front',
                callback: (res) => {
                    if (imageType === "C3") {
                        if (field === "buyerOCR") {
                            form.setFieldsValue({
                                "buyer.creditNo": res["社会信用代码"]["words"],
                                "buyer.name": res["单位名称"]["words"],
                                //"buyer.censusAddress": res["地址"]["words"],
                                "buyer.residenceAddress": res["地址"]["words"],
                            });
                        } else {
                            form.setFieldsValue({
                                "seller.creditNo": res["社会信用代码"]["words"],
                                "seller.name": res["单位名称"]["words"],
                                //"seller.censusAddress": res["地址"]["words"],
                                "seller.residenceAddress": res["地址"]["words"],
                            });
                        }
                    } else {
                        if (field === "buyerOCR") {
                            form.setFieldsValue({
                                "buyer.creditNo": res["公民身份号码"]["words"],
                                "buyer.name": res["姓名"]["words"],
                                //"buyer.censusAddress": res["住址"]["words"],
                                "buyer.residenceAddress": res["住址"]["words"],
                            });
                        } else {
                            form.setFieldsValue({
                                "seller.creditNo": res["公民身份号码"]["words"],
                                "seller.name": res["姓名"]["words"],
                                //"seller.censusAddress": res["住址"]["words"],
                                "seller.residenceAddress": res["住址"]["words"],
                            });
                        }
                    }
                }
            });
        }
        if (field === "otherImage") {
            const list = this.state.otherImage;
            list.push(base64);
            this.setState({ "otherImage": list });
        } else {
            const list = this.state.fileList;
            const imageUrl = this.state.imageUrl;
            if (field === "vehicleOCR") {
                list["vehicleLicense"] = base64;
                delete imageUrl["vehicleLicense"];
            } else if (field === "buyerOCR") {
                list["buyerCreditFront"] = base64;
                delete imageUrl["buyerCreditFront"];
            } else if (field === "sellerOCR") {
                list["sellerCreditFront"] = base64;
                delete imageUrl["sellerCreditFront"];
            } else {
                list[field] = base64;
                delete imageUrl[field];
            }
            this.setState({ "fileList": list, "imageUrl": imageUrl });
        }
    }
    handleRemoveImage = (field, index) => {
        if (field === "otherImage") {
            const list = this.state.otherImage;
            const otherImagesUrl = this.state.otherImagesUrl;
            list.splice(index, 1);
            otherImagesUrl.splice(index, 1);
            this.setState({ "otherImage": list, "otherImagesUrl": otherImagesUrl });
        } else {
            const list = this.state.fileList;
            const imageUrl = this.state.imageUrl;
            delete list[field];
            delete imageUrl[field];
            this.setState({ "fileList": list, "imageUrl": imageUrl });
        }
    }
    showModal = (field) => {
        this.setState({ visible: true, imageField: field });
        this.state.initScanner();
    };
    hiddenModal = () => {
        this.setState({ visible: false });
    };
    handleScan = (base64) => {
        if (base64 != null && base64 !== "") {
            base64 = "data:image/jpeg;base64," + base64.replace(/\r\n/g, "");
            if (this.state.imageField === "otherImage") {
                const list = this.state.otherImage;
                list.push(base64);
                this.setState({ "otherImage": list });
            } else {
                // const list = this.state.fileList;
                // list[this.state.imageField] = base64;
                // this.setState({ "fileList": list });
                this.handleUploadImage(this.state.imageField, { base64 });
            }
        }
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="申请信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                //zIndex={1001}
                afterClose={() => {
                    this.setState({ activeKey: 'deal' });
                    this.props.form.resetFields();
                }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Tabs tabPosition='left' activeKey={this.state.activeKey}
                        onChange={(activeKey) => {
                            this.setState({ activeKey: activeKey });
                        }}
                    >
                        <Tabs.TabPane tab="交易信息" key="deal">
                            {this.createDom(dealField)}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="车辆信息" key="vehicle">
                            {this.createDom(vehicleField)}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="买方信息" key="buyer">
                            {this.createDom(buyer)}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="卖方信息" key="seller">
                            {this.createDom(seller)}
                        </Tabs.TabPane>
                        <Tabs.TabPane tab="相关照片" key="iamge">
                            <Row>
                                <Divider orientation="left">过户照片</Divider>
                                {this.createImageDom(tradeImage)}
                            </Row>
                            {/* <Row>
                                <Divider orientation="left">查验照片</Divider>
                                {this.createImageDom(checkImage)}
                            </Row> */}
                            <Row>
                                <Divider orientation="left">其他照片</Divider>
                                {this.createOtherImageDom()}
                            </Row>
                            <Modal visible={this.state.previewVisible} footer={null} onCancel={this.handleCancel}>
                                <img alt="" style={{ width: '100%' }} src={this.state.previewImage} />
                            </Modal>
                        </Tabs.TabPane>
                    </Tabs>

                </Form>
                <Scanner
                    visible={this.state.visible}
                    onCancel={this.hiddenModal.bind(this)}
                    initScanner={(func) => { this.setState({ initScanner: func }) }}
                    onScan={this.handleScan}
                // successCallback={}
                />
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在保存"
                />
            </Modal>
        );
    }
}

const ApplicationEdit = Form.create()(ApplicationEditForm);

export default ApplicationEdit;